module.exports = __webpack_public_path__ + "static/media/news-hero.c380a2d0.png";